<template>
  <div class="list-box">
    <div class="list-top">
      <h3>{{ title }}</h3>
      <div class="list-top-more" @click="toMoreList">
        更多<van-icon name="arrow" class="list-top-more-icon" />
      </div>
    </div>
    <slot name="content"></slot>
  </div>
</template>
  
  <script>
import { Icon } from "vant";
export default {
  components: {
    "van-icon": Icon,
  },
  props: ["title"],
  methods: {
    toMoreList() {
      this.$emit("toMore");
    },
  },
};
</script>
  
  <style scoped lang="scss">
.list-box {
  margin: 0 auto 12px;
  padding: 12px;
  width: 351px;
  //   height: 594px;
  background-color: #ffffff;
  border-radius: 8px;
  .list-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    h3 {
      font-size: 17px;
      color: #333333;
    }
    .list-top-more {
      font-size: 13px;
      color: #999999;
      .list-top-more-icon {
        margin-left: 5px;
      }
    }
  }
}
</style>